import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/leistungen/performance-marketing/meta-ads")({
  component: () => <Outlet />,
});
